import { createConsola } from "consola/basic";
import type { LoggingConfig } from "../types/logger.js";
import { DEFAULT_LOGGING_CONFIG, LOG_NAMESPACES } from "../types/logger.js";

// Global consola instance
let globalConsola: ReturnType<typeof createConsola> = createConsola({
  level: DEFAULT_LOGGING_CONFIG.level ?? 3,
});

/**
 * Configure global logging
 */
export function configureLogging(config: LoggingConfig): void {
  const finalConfig = { ...DEFAULT_LOGGING_CONFIG, ...config };

  if (finalConfig.enabled === false) {
    // Explicitly disabled - use silent mode with no reporters
    globalConsola = createConsola({
      level: -999,
      reporters: [], // No reporters = no output
    });
  } else if (finalConfig.enabled && finalConfig.level !== -999) {
    globalConsola = createConsola({ level: finalConfig.level ?? 3 });
  } else {
    // Use Consola's silent mode - level 0 with no reporters
    globalConsola = createConsola({
      level: -999,
      reporters: [], // No reporters = no output
    });
  }
}

/**
 * Get logger for a component
 */
export function getLogger(
  namespace: keyof typeof LOG_NAMESPACES
): ReturnType<typeof globalConsola.withTag> {
  return globalConsola.withTag(LOG_NAMESPACES[namespace]);
}

/**
 * Simple hex dump for debugging
 */
export function hexDump(data: Uint8Array, maxBytes = 64): string {
  const limited = data.length > maxBytes ? data.slice(0, maxBytes) : data;
  const hex = Array.from(limited)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join(" ");

  if (data.length > maxBytes) {
    return `${hex} ... (${data.length - maxBytes} more bytes)`;
  }
  return hex;
}
